import type { BoatsResponse } from '@/pocketbase/pocketbase-types';
import { writable } from 'svelte/store';

const boat: BoatsResponse = {} as BoatsResponse;

export const uploadBoatStore = writable(boat);
